import { Expression } from './Expression.js';
export class DefExpression extends Expression {
    constructor(key, value) {
        super();
        this.key = key;
        this.value = value;
    }
    getKey() {
        return this.key;
    }
    getValue() {
        return this.value;
    }
    evaluate(visitor, localVariables) {
        const obj = visitor.getObjectToEvaluate();
        if (obj) {
            obj[this.getKey()] = this.getValue()
                .evaluate(visitor, localVariables);
        }
        else {
            console.warn('Cannot def expression');
        }
    }
}
//# sourceMappingURL=DefExpression.js.map